require('esn-frontend-common-libs/src/frontend/vendor-libs.js');
require('esn-frontend-common-libs/src/frontend/js/modules/header/header.js');
require('esn-frontend-mailto-handler/src/index.js');
require('esn-frontend-account-inbox/src/index.js');

require('./app/app.js');
require('./all.less');
